export default __webpack_public_path__ + "static/ai-marketing-1-a964e644c41a14016ba50f2a90d29af2.png";